// Chicken demand is counted in six-ounce equivalents, not full-size meals.
export function orderingQuantities(item, factor, onHand) {
  const demand = item.portion_equivalent_meals ?? item.total_meal_count ?? 0
  // A component whose own recipe product needs more raw weight (whole mango
  // for diced mango) orders the recipe amount; the ratio follows factor edits.
  const recipeRatio = item.purchase_items?.length && item.component_raw_lbs > 0
    ? item.recipe_raw_lbs / item.component_raw_lbs : 1
  const raw = demand * factor * Math.max(1, recipeRatio)
  const withBuffer = raw * 1.05
  return { raw, withBuffer, toOrder: Math.max(0, withBuffer - onHand) }
}
